import getDefaultTab from 'lib/getDefaultTab'
import useAppContext from 'hooks/useAppContext'
import useFeature, { featureTypes } from 'hooks/useFeature'
import useSetting, { settingTypes } from 'hooks/useSetting'
import useURLParams from 'hooks/useURLParams'

const useDefaultTab = () => {
  let defaultTab = useSetting(settingTypes.DEFAULT_TAB)
  const urlParams = useURLParams()
  const referrer = urlParams.get('referrer')

  // TEMPORARY: Override default tab to dashboard for staff users with Op Note license
  // until we can set dashboard as the default tab for those users in the backend
  const { currentAccount: { type: currentAccountType } = {} } = useAppContext()

  const isStaff = currentAccountType === 'Staff'
  const canViewDashboard = useFeature(featureTypes.VIEW_DASHBOARD)

  if (isStaff && canViewDashboard) {
    defaultTab = 'dashboard'
  }

  return getDefaultTab(defaultTab, referrer)
}

export default useDefaultTab
